import { __generator } from "tslib";
import { eventChannel, buffers } from 'redux-saga';
import { fork, all, take, put } from 'redux-saga/effects';
import { Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import { appMounted } from '../../redux/app/actions';
import { messageReceived } from './action';
var logger = ddt.createLogger('sharedMessages');
function tryParseMessage(event) {
    var expectedOrigin = Url.origin();
    if (event.origin !== expectedOrigin) {
        logger.log('Invalid origin', event.origin);
        return;
    }
    var data;
    try {
        data = JSON.parse(event.data);
        if (!data.type) {
            logger.log('Missing message type', data);
            return;
        }
    }
    catch (e) {
        logger.log('Error parsing data', e, data);
        return;
    }
    return data;
}
function handleAppMount() {
    var messageChannel, event_1, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, take(appMounted)];
            case 1:
                _a.sent();
                messageChannel = eventChannel(function (emitter) {
                    window.addEventListener('message', emitter);
                    return function () {
                        window.removeEventListener('message', emitter);
                    };
                }, 
                // going absolutely safe here, never drop a message
                buffers.expanding());
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, take(messageChannel)];
            case 3:
                event_1 = _a.sent();
                logger.log('Got messageEvent: ', event_1);
                message = tryParseMessage(event_1);
                if (!message) {
                    return [3 /*break*/, 2];
                }
                logger.log('Message received', message);
                return [4 /*yield*/, put(messageReceived(message))];
            case 4:
                _a.sent();
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([fork(handleAppMount)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map